<template>
  <div
    class="blog-item-container"
    :class="article.params.bloggers_post ? 'bloggers-post' : ''"
  >
    <div class="item carousel">
      <a
        class="img-wrapper"
        :style="imgstyle"
        :href="article.url"
        target="_blank"
        @click="emit('goArticle')"
      >
        <div class="img-wrapper-padding">
          <div
            class="article-title heading-xs"
            :class="article.params.bloggers_post ? 'bloggers-title' : ''"
          >
            {{
              article.title
                .replace(/\s/gi, 'sdvkhjbsknmf')
                .replace(/sdvkhjbsknmf/gi, ' ')
            }}
          </div>

          <div v-if="!article.params.bloggers_post" class="article-info">
            <span class="article-info-item time-to-read body-s-regular"
              >{{ article.params.reading_time }}&nbsp;мин</span
            >
            <span class="article-info-item body-s-regular">{{
              article.params.views
            }}</span>
          </div>

          <div v-else class="article-blogger-info">
            <div
              class="bloggers-avatar"
              :style="`background: url('${article.params.bloggers_info?.bloggers_avatar}') center / contain no-repeat`"
            >
              <img
                src="/static/images/icon/youtube_icon.svg"
                alt="18+"
                class="youtube_icon"
              />
            </div>
            <div class="bloggers-name body-m-regular">
              {{ article.params.bloggers_info?.bloggers_name }}
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { BlogArticle } from '~/interfaces/api';

const emit = defineEmits(['goArticle']);

const props = defineProps({
  article: {
    type: Object as () => BlogArticle,
    default: () => {},
  },
});
const imgstyle = computed(() => {
  const background =
    'background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%) ';
  if (!props.article.params.image) return background;
  return `${background}, url(${props.article.params.image}), lightgray 50%`;
});
// \u00a0 = &nbsp;
</script>
<style lang="scss" scoped>
.blog-item-container {
  position: relative;

  &.bloggers-post {
    .img-wrapper-padding {
      background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0) 45%);
    }
  }

  .item {
    background-color: $achromatic-card-bg;
    padding: 0;
    position: relative;
    cursor: pointer;
    width: 232px;
    height: 100px;

    @include md-block {
      width: 340px;
      height: 112px;
    }
    @include xxl-block {
      width: 386px; //389
      height: 134px;
    }

    .img-wrapper {
      display: block;
      height: 100%;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      border-radius: 8px;

      .img-wrapper-padding {
        padding: 12px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 8px;
        @include xxl-block {
          padding: 16px;
        }

        .article-info {
          display: flex;
          gap: 12px;
          align-items: center;

          .article-info-item {
            padding-left: 15px;
            position: relative;
            color: $achromatic-hover;

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              mask: url('/static/images/icon/page-views.svg') center / contain
                no-repeat;
              width: 12px;
              height: 9px;
              color: $achromatic-hover;
              background: $achromatic-hover;
              margin-top: 3px;
              @include xl-block {
                margin-top: 0;
                width: 12px;
                height: 14px;
              }
            }

            &.time-to-read {
              padding-left: 13px;

              &:before {
                width: 9px;
                height: 12px;
                margin-top: 1px;
                mask: url('/static/images/icon/stopwatch.svg') center / contain
                  no-repeat;
              }
            }
          }
        }

        .article-title {
          color: $white;
          word-break: break-word;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 3;

          &.bloggers-title {
            -webkit-line-clamp: 2;
          }
        }

        .article-blogger-info {
          width: 100%;
          display: flex;
          gap: 4px;
          justify-content: flex-start;
          align-items: center;
          flex-direction: row;
          color: $white;
          @include md-block {
            gap: 8px;
          }

          .bloggers-avatar {
            border-radius: 21px;
            width: 32px;
            height: 32px;
            border: 1px solid white;
            position: relative;
            flex-shrink: 0;

            img.youtube_icon {
              position: absolute;
              top: -2px;
              right: 0;
              width: 12px;
            }

            @include md-block {
              width: 38px;
              height: 38px;
              img.youtube_icon {
                width: 14px;
              }
            }
            @include xxl-block {
              width: 42px;
              height: 42px;
              img.youtube_icon {
                width: 16px;
              }
            }
          }

          .bloggers-name {
            word-break: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
            //max-height: 32px;
          }
        }
      }
    }
  }

  .half-opacity {
    opacity: 0.5;
  }
}
</style>
